import React from "react";
import Portfolio1 from "../assets/img/portfolio/portfolio1.jpg";
import BankImage from "../assets/img/client/bank-app-image.png";
// import Portfolio2 from "../assets/img/portfolio/portfolio2.jpg";

const Portfolio = () => {
  return (
    <>
      <section id="portfolio">
        <div className="st-height-b100 st-height-lg-b80"></div>
        <div className="container">
          <div className="st-section-heading st-style1">
            <h4 className="st-section-heading-title">PORTFOLIOS</h4>
            <h2 className="st-section-heading-subtitle">PORTFOLIOS</h2>
          </div>
          <div className="st-height-b25 st-height-lg-b25"></div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="card bg-dark">
                <img
                  src={BankImage}
                  className="card-img-top"
                  alt="Bank Application"
                />
                <div className="card-body">
                  <h5 className="card-title">Bank Application</h5>
                  <p className="card-text">
                    Built using Javascript,BootStap,Html
                  </p>
                  <a
                    href="http://vickybankapp.netlify.app/"
                    className="btn btn-primary"
                  >
                    View Project
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-5">
              <div className="card bg-dark">
                <img
                  src={Portfolio1}
                  className="card-img-top"
                  alt="Bank Application"
                />
                <div className="card-body">
                  <h5 className="card-title">Chat Bot Application System</h5>
                  <p className="card-text">
                    Built using Javascript.Html and Chat-Openai-api
                  </p>
                  <a
                    href="https://chat-bot-system.vercel.app/"
                    className="btn btn-primary d-block mx-auto"
                  >
                    View Project
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-5">
              <div className="card bg-dark">
                <img
                  src={Portfolio1}
                  className="card-img-top"
                  alt="Bank Application"
                />
                <div className="card-body">
                  <h5 className="card-title">Travel Website App</h5>
                  <p className="card-text">
                    Travel web app using nextjs,tailwind-css
                  </p>
                  <a
                    href="https://travel-web-app-fawn.vercel.app/"
                    className="btn btn-primary d-block mx-auto"
                  >
                    View Project
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-5">
              <div className="card bg-dark">
                <img
                  src={Portfolio1}
                  className="card-img-top"
                  alt="E-Voting System Application"
                />
                <div className="card-body">
                  <h5 className="card-title text-center">
                    E-Voting System Application Server
                  </h5>
                  <p className="card-text text-center">
                    Built using Express-js, MongoDb, Nodejs
                  </p>
                  <a
                    href="https://e-voting-system-server.onrender.com"
                    className="btn btn-primary d-block mx-auto"
                  >
                    View Project
                  </a>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center mx-auto w-100">
              <a href="https://github.com/vickymayowa">
                <button className="btn btn-primary mt-5">View More</button>
              </a>
            </div>
          </div>
        </div>
        <div className="st-height-b100 st-height-lg-b80"></div>
      </section>
    </>
  );
};

export default Portfolio;
